import type { IStickyColumn } from './types';

/**
 * Получает вложенное значение из объекта по пути с точечной нотацией.
 * Заменяет lodash.get для поддержки путей вида "user.name.first".
 */
export function getDeep(obj: unknown, path: string): unknown {
  return path.split('.').reduce((acc: unknown, key: string) => {
    if (acc !== null && acc !== undefined && typeof acc === 'object') {
      return (acc as Record<string, unknown>)[key];
    }
    return undefined;
  }, obj);
}

const STICKY_COLUMN_DEFAULT: IStickyColumn = {
  left: '0px',
};

export const getStickyProps = (
  sticky?: IStickyColumn | boolean,
): IStickyColumn | Record<string, never> => {
  if (!sticky) {
    return {};
  }

  if (typeof sticky === 'boolean') {
    return STICKY_COLUMN_DEFAULT;
  }

  return sticky;
};
